// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UIZ-","clinicsSelect":"styles_clinicsSelect__39JDB"};